// extracted by mini-css-extract-plugin
export default {"InputsSectionContainer":"InputsSectionContainer_InputsSectionContainer__hJB5-"};